import styles from '@/Components/SideMenu/modules/SynchModal/SynchModal.scss';
import { ButtonsWrapper } from '@/Components/Forms/ButtonsSection/ButtonsSection';
import { Button } from '@/Components/Controls/Button/Button';
import { PagesRouting } from '@/Routing';
import { BUTTON_THEMES } from '@/Components/Controls/Button/ButtonThemes';
import Countdown from 'react-countdown';
import { TreeView } from '@/Components/TreeView/TreeView';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { useLocalization } from '@/Hooks';
import { BackgroundTasksApi } from '@/Api/BackgroundTasks/BackgroundTasksApi';
import { dateTimeUtils } from '@/Utils';
import { MpOrdersApi } from '@/Api/MpOrders';
import { MpFeedbacksApi } from '@/Api/MpFeedback';
import { Nullable } from '@/Types';
import { useMarketplaceOptions } from './hooks/useMarketplaceOptions';

type Props = {
  closeModalWindow: () => void;
};

export function Marketplace({ closeModalWindow }: Props) {
  const {
    modalWindows: {
      mpSynchronization: {
        ModalTabs,
        MarketplaceTab: { NoAccountsMessage },
      },
    },
    buttons: { No, Yes },
    modules: { Synchronize },
  } = useLocalization();

  const history = useHistory();
  const [marketplaceSynchDate, setMarketplaceSynchDate] = useState<Nullable<number>>(null);
  const { mpTreeViewItems, selectedAccounts, setSelectedAccounts } = useMarketplaceOptions();

  const synchronize = () => {
    Promise.all([
      MpOrdersApi.synchOrders({ mpAccountIds: selectedAccounts }),
      MpFeedbacksApi.synchFeedbacks({ mpAccountIds: selectedAccounts }),
    ]).then(() => {
      closeModalWindow();
    });
  };

  const getLastSynchDate = async () => {
    const response = await BackgroundTasksApi.getLastSynchDate();
    setMarketplaceSynchDate(dateTimeUtils.convertTimeToSeconds(response.lastMarketplaceSynchDate));
  };

  useEffect(() => {
    getLastSynchDate();
  }, []);

  if (mpTreeViewItems.length <= 0) {
    return (
      <div>
        <h3 className={styles.title}>{Synchronize}</h3>
        <p className={styles.text}>{NoAccountsMessage}</p>

        <ButtonsWrapper>
          <Button text={No} onClick={closeModalWindow} theme={BUTTON_THEMES.SUCCESS_TRANSPARENT} />
          <Button
            text={Yes}
            onClick={() => history.push(PagesRouting.SettingsPages.MarketplacesSettings)}
            theme={BUTTON_THEMES.SUCCESS}
          />
        </ButtonsWrapper>
      </div>
    );
  }

  return (
    <div>
      {Boolean(marketplaceSynchDate) && (
        <div className={styles.timer}>
          <Countdown
            daysInHours={true}
            date={Date.now() + Number(marketplaceSynchDate) * 1000}
            onComplete={() => setMarketplaceSynchDate(null)}
          />
        </div>
      )}

      <h3 className={styles.title}>{Synchronize}</h3>
      <p className={styles.text}>{ModalTabs.Marketplace.text}</p>

      <TreeView
        className={styles.treeView}
        checkboxesMode={'selectAll'}
        selectionMode={'multiple'}
        onItemClick={() => null}
        items={mpTreeViewItems}
        width={'100%'}
        onSelectionChanged={(ev) => setSelectedAccounts(ev.ids)}
      />

      <ButtonsWrapper>
        <Button
          autoFocus={true}
          className={styles.wideButton}
          disabled={!selectedAccounts?.length || !!marketplaceSynchDate}
          text={Synchronize}
          theme={BUTTON_THEMES.SUCCESS}
          onClick={synchronize}
        />
      </ButtonsWrapper>
    </div>
  );
}
